import React, {useEffect, useRef, useState} from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import Item from './Item'
import Logo from './Logo'
import './styles.css'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'

const SideBarSpace = styled.div`
	box-sizing: border-box;
	padding: 20px 16px 20px 20px;
	&[data-collapsed="false"] {
		/* min-width: 264px; */
		width: 264px;
	}
	&[data-collapsed="true"] {
		width: 96px;
	}
	transition: width 0.5s 0s ease-in-out;
	color: rgba(255, 255, 255, 0.60);
	font-family: "Basis Grotesque Pro";
	font-style: normal;
	font-weight: 400;
`

const MenuTitle = styled.div`
	box-sizing: border-box;
	padding: 24px 0 16px;
	font-family: "Basis Grotesque Pro";
	font-family: inherit;
	font-size: 12px;
	line-height: 100%; /* 12px */
	letter-spacing: 0.36px;
	text-transform: uppercase;
`

export const Sidebar = (props) => {
	const { collapsed } = props
	const {t} = useTranslation();
	const {navigationMenu} = useSelector(
		(state) => ({
			navigationMenu: state.navigationMenu
		}),
		shallowEqual
	)
	const leftSidebarRef = useRef(null)
	const [closeSubMenusFlag, setCloseSubMenusFlag] = useState(0)
	const [activeClickedMenu, setActiveClickedMenu] = useState('')

	const onOutsideClickHandler = (event) => {
		//console.log('onOutsideClickHandler', {leftSidebarRefCurrent: leftSidebarRef.current, eventTarget: event.target});
		if (leftSidebarRef.current && leftSidebarRef.current.contains(event.target)) {
			// in leftSidebarRefTarget - return
			return
		}
		//console.log('Will be CLOSED');
		setCloseSubMenusFlag((prev) => prev + 1)
	}

	useEffect(() => {
		document.addEventListener('click', onOutsideClickHandler)

		return () => {
			document.removeEventListener('click', onOutsideClickHandler)
		}
	}, [])
	//console.log('!!!', {navigationMenu});

	const updateActiveClickedMenu = (newTitle) => {
		if (activeClickedMenu === newTitle) {
			setActiveClickedMenu('')
		} else {
			setActiveClickedMenu(newTitle)
		}
	}

	return (
		<SideBarSpace data-collapsed={collapsed} ref={leftSidebarRef}>
			<Logo />
			{navigationMenu.map((menu, i) => (
				<div key={i}>
					<MenuTitle>{t(menu.title)}</MenuTitle>
					<ul>
						{menu.items.map((l0, a) => (
							<li key={a} className="l0">
								<Item {...l0}
											collapsed={collapsed}
											closeSubMenusFlag={closeSubMenusFlag}
											hidden={activeClickedMenu !== `${l0.title}+${l0.url}`}
											setHidden={updateActiveClickedMenu}
								/>
								<ul>
									{l0.items.map((l1, b) => (
										<li key={b} className="l1">
											<Item {...l1}
														collapsed={collapsed}
														closeSubMenusFlag={closeSubMenusFlag}
														hidden={activeClickedMenu !== `${l1.title}+${l1.url}`}
														setHidden={updateActiveClickedMenu}
											/>
											<ul>
												{l1.items.map((l2, c) => (
													<li key={c} className="l2">
														<Item {...l2}
																	collapsed={collapsed}
																	closeSubMenusFlag={closeSubMenusFlag}
																	hidden={activeClickedMenu !== `${l2.title}+${l2.url}`}
																	setHidden={updateActiveClickedMenu}
														/>
														<ul>
															{l2.items.map((l3, d) => (
																<li key={d} className="l3">
																	<Item {...l3} collapsed={collapsed}
																				closeSubMenusFlag={closeSubMenusFlag}
																				hidden={activeClickedMenu !== `${l3.title}+${l3.url}`}
																				setHidden={updateActiveClickedMenu}
																	/>
																	<ul>
																		{l3.items.map((l4, e) => (
																			<li key={e} className="l4">
																				<Item {...l4}
																							collapsed={collapsed}
																							closeSubMenusFlag={closeSubMenusFlag}
																							hidden={activeClickedMenu !== `${l4.title}+${l4.url}`}
																							setHidden={updateActiveClickedMenu}
																				/>
																			</li>
																		))}
																	</ul>
																</li>
															))}
														</ul>
													</li>
												))}
											</ul>
										</li>
									))}
								</ul>
							</li>
						))}
					</ul>
				</div>
			))}
		</SideBarSpace>
	)
}

export default Sidebar
